<script setup lang="ts">
import { useListingFilters } from '~/app/composables/useListingFilters';
import { FILTER_ALL } from '~/app/types/listingTypes';

const props = defineProps<{
  taxonomy?: string;
  sanityKey?: string;
  listingType?: string;
  postsPerPage?: number;
}>();

const { t } = useI18n();

const emit = defineEmits<{
  'update:filter': [slug: Array<string>]
}>();

// Use the new filters composable
const { activeFilter, taxonomyList, updateFilter } = await useListingFilters({
  sanityKey: props.sanityKey,
  listingType: props.listingType,
  taxonomy: props.taxonomy,
  postsPerPage: props.postsPerPage,
});

function handleFilterClick(slug: Array<string>) {
  updateFilter(slug);
  emit('update:filter', slug);
}

</script>

<template>
  <div v-if="taxonomyList && taxonomyList.length > 0" class="c-filter">
    <BaseTag
      :data-slug="FILTER_ALL.slug"
      class="c-filter__tag"
      :class="{ 'c-filter__tag--active': activeFilter[0] === FILTER_ALL.slug }"
      @click="handleFilterClick([FILTER_ALL.slug])"
    >
      {{ t(`listings.tags.${FILTER_ALL.slug}`) }}
    </BaseTag>

    <BaseTag
      v-for="taxonomyItem in taxonomyList"
      :key="taxonomyItem._id"
      :data-slug="taxonomyItem.slug"
      class="c-filter__tag"
      :class="{'c-filter__tag--active': activeFilter[0] === taxonomyItem.slug}"
      @click="handleFilterClick([taxonomyItem.slug])"
    >
      {{ taxonomyItem.title }}
    </BaseTag>
  </div>
</template>

<style scoped>
  .c-filter {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: theme('spacing.12');
    margin-bottom: theme('spacing.32');

    @screen tablet-wide {
      display: flex;
      justify-content: center;
      gap: theme('spacing.16');
      margin-bottom: theme('spacing.40');
    }
  }

  .c-filter__tag {
    cursor: pointer;
    display: flex;
    padding: theme('spacing.4') theme('spacing.8');
    align-items: center;
    line-height: 1.5;
    white-space: break-spaces;
    word-break: normal;
    width: 100%;
    justify-content: center;

    @screen tablet-wide {
      padding: theme('spacing.4') theme('spacing.12');
      width: fit-content;
    }
    &:hover,
    &--active {
      color: var(--tag-text-hover-color);
      border-color: var(--tag-border-hover-color);
    }
  }
</style>
